export const statusColor = [
  "#ebf2fe",
  "#fff7eb",
  "#eefbf5",
  "#ca6df9",
  "#17367c",
  "#ebf2fe",
  "#fff7eb",
  "#eefbf5",
];

export const GDColor = [
  "#E6E6FA",
  "#B0E0E6",
  "#E0FFFF",
  "#FFFFE0",
  "#eefbf5",
  "#FFFAFA",
  "#ebf2fe",
  "#fff7eb",
  "#ca6df9",
  "#17367c",
  "#ebf2fe",
  "#fff7eb",
  "#eefbf5",
];

export const BBFColor = [
  "#E6E6FA",
  "#F5F5DC",
  "#FFFAFA",
  "#17367c",
  "#ebf2fe",
  "#fff7eb",
  "#eefbf5",
  "#ebf2fe",
  "#fff7eb",
  "#eefbf5",
  "#ebf2fe",
];
